export const TRAINER_PROFILE_PICTURE = '/trainers/profilePhoto/';
export const CLIENT_PROGRESS_IMAGES = '/clients/progress';
